import React from "react";
import { ListGroup } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import VocabGeneralSettings from "../../../../ConfigFiles/multilingual/VocabGeneralSettings";
import { FRONTEND_ROUTES } from "../../../../ConfigFiles/Routes/frontend_routes";
//  Context
import { useLanguage } from "../../../../API/Context/LanguageContext";


const GeneralSettings = ({  }) => {
  //  Consume Context
  const { lan } = useLanguage()

  const navigate = useNavigate();

  return (
    <div className="w-100 h-100 d-flex flex-column p-3">
      <h5>{VocabGeneralSettings.account[0]}</h5>
      <ListGroup className="mb-4">
        <ListGroup.Item action onClick={() => navigate(FRONTEND_ROUTES.register_professional)}>
          {VocabGeneralSettings.professional_register[lan]}
        </ListGroup.Item>
      </ListGroup>

    </div>
  );
};

export default GeneralSettings;
